var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlasfaser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 744.094,
    height: 1052.362,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E5E4",
    d: "M99.571 143.846h534.001v612.153H99.571z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D3D1",
    d: "M99.571 758.039h534.001v110.36H99.571z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#89b9db",
    d: "M132.368 167.08h62v81.822h-62zM203.767 167.08h63.64v81.822h-63.64zM468.083 167.08h62v81.822h-62zM539.482 167.08h63.64v81.822h-63.64zM132.368 280.722h62v81.822h-62zM203.767 280.722h63.64v81.822h-63.64zM468.083 280.722h62v81.822h-62zM539.482 280.722h63.64v81.822h-63.64zM132.368 507.811h62v81.822h-62zM203.767 507.811h63.64v81.822h-63.64zM468.083 507.811h62v81.822h-62zM539.482 507.811h63.64v81.822h-63.64zM132.368 622.154h62v81.822h-62zM203.767 622.154h63.64v81.822h-63.64zM468.083 622.154h62v81.822h-62zM539.482 622.154h63.64v81.822h-63.64zM132.368 393.859h62v81.822h-62zM203.767 393.859h63.64v81.822h-63.64zM468.083 393.859h62v81.822h-62zM539.482 393.859h63.64v81.822h-63.64zM308.803 643.367H422.95v112.127H308.803z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#146990",
    d: "M363.312 756.981V643.379h4.806v113.602z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 493.20902,211.08354 -6.29304,-0.83816 c -5.5102,0.60063 -6.00013,1.33882 -11.38473,6.84837 l -5.71875,5.875 -17.28125,0.25 -17.25,0.28125 L 435,270.75 434.75,318 l 2.5,0 2.53125,0 0,-43.0625 c 0,-27.77396 0.36365,-43.75256 1.03125,-45 0.9635,-1.80038 0.45034,-2.00622 17.75,-1.84375 9.19286,0.0863 16.24722,0.26796 14.28125,0.78125 0.041,2.60107 0.41808,2.85692 2.71875,4.46875 6.59541,4.62069 10.937,6.08208 16,4.71875 7.0035,-1.88584 10.21875,-6.52607 10.21875,-14.75 0,-4.06185 -0.74971,-8.20047 -4.40625,-10.08354 z M 239.625,329.03125 c -3.18673,-0.0281 -6.45821,0.69279 -8.78125,2.21875 -6.14249,10.07383 -6.2006,10.63725 -2.84375,20.59375 4.4378,3.85493 7.09425,5.15625 10.59375,5.15625 3.9914,0 9.7326,-2.50787 11.5,-5.03125 0.7973,-1.13831 2.40413,-2.29465 3.72129,-3.26914 1.1336,-0.83868 2.12203,-0.85094 3.21621,-1.57461 -0.185,-0.84131 20.1461,-1.125 78.25,-1.125 l 78.5,0 0,-2.8125 c 0,-1.54 -0.55875,-3.34 -1.21875,-4 -0.9126,-0.91263 -19.71111,-1.1875 -78.5,-1.1875 -58.3347,0 -77.21985,-0.27655 -77.03125,-1.15625 -2.37513,-0.34553 -2.47608,-0.47596 -4.09711,-1.16724 -1.8182,-0.39567 -2.80859,-2.15683 -3.46539,-3.02026 -1.76569,-2.32098 -5.74652,-3.58892 -9.84375,-3.625 z m 196.375,0.125 c -6.55839,0.24992 -12.21187,5.50469 -12.21875,14.03125 -0.004,5.36532 3.218,10.2126 8.4375,12.40625 3.06801,1.28943 3.60742,1.46633 8.625,0.25 2.12951,-0.51622 5.0944,-2.43357 6.625,-4.03125 2.4002,-2.50521 2.78125,-3.7338 2.78125,-8.8125 0,-4.89079 -0.4376,-6.3239 -2.5,-8.53125 -3.56831,-3.81903 -7.81496,-5.46245 -11.75,-5.3125 z m 0.8125,37 c -2.9849,0.19135 -2.48091,212.53406 -3,200.59375 -0.2692,364.13111 0.89296,91.77358 -0.21834,207.13823 0,8.1331 -1.73176,10.05072 -7.09416,12.76802 -7.6794,3.8914 -14.15225,11.2445 -17.28125,19.6875 -1.7789,9.71579 -2.9175,9.44563 -2.4375,21.71875 0,4.8015 4.4256,13.31795 10.0625,19.34375 8.5201,9.1081 15.30065,12.0365 27.96875,12.0625 9.0507,0.0183 9.9551,-0.1756 17.1875,-3.75 8.7761,-4.3374 14.64645,-10.24625 18.59375,-18.71875 2.2263,-4.77881 2.592,-6.8768 2.625,-16 0.0336,-9.376 -0.2571,-11.13025 -2.6875,-16.34375 -3.033,-6.5063 -13.17955,-17.2205 -17.28125,-18.25 -3.4733,-0.8717 -4.46975,-3.23255 -4.46875,-10.59375 0.0106,-66.91607 0.7357,-43.93104 -0.4375,-142.28125 0.3407,-61.06809 0.4855,-121.25913 0.4375,-157.53125 0,-5.36484 0.44,-9.06496 1.1875,-9.8125 1.4455,-1.44548 10.8125,-1.60621 10.8125,-0.1875 0,0.55 0.5834,1 1.3125,1 0.7291,0 2.4166,1.17538 3.75,2.625 6.5719,7.14532 16.79995,7.59305 22.53125,0.96875 4.7222,-10.19792 4.99155,-7.80632 0.15625,-18.96875 -5.5095,-3.91708 -11.24785,-5.1703 -15.46875,-3.375 -3.9239,1.66897 -12.9585,9.69088 -11.1875,9.9375 0.765,0.10651 -3.09375,0.44401 -8.59375,0.75 l -10,0.5625 -0.21875,147.5 c -0.0449,28.86262 -0.42642,53.4317 -1,74 l 0,91.84375 -0.28125,0 c -0.004,0.67222 0.004,1.29132 0,1.96875 0,2.64 -0.55875,5.34 -1.21875,6 -0.66,0.66 -2.80125,1.1875 -4.78125,1.1875 -4.7847,0 -6.2217,-1.47053 -6.2217,-7.21213 -0.002,-0.67516 0.0267,-1.27387 0.0246,-1.94412 -0.26678,-24.56053 -0.0842,-50.69417 -0.0842,-75.8125 -0.87099,-31.38733 -1.04881,-74.76342 -0.0625,-130.40625 0.6078,-190.15003 0.53435,-199.32002 -1.15625,-199.96875 -0.5629,-0.21602 -1.04234,-0.52734 -1.46875,-0.5 z",
    fill: "yellow"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#146990",
    d: "M30.605 754.12h648.433v4.806H30.605z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M436.343 315.128c-15.188 0-27.5 12.312-27.5 27.5 0 15.187 12.312 27.5 27.5 27.5 15.187 0 27.5-12.313 27.5-27.5 0-15.188-12.313-27.5-27.5-27.5zm0 5.125c12.426 0 22.5 10.073 22.5 22.5 0 12.426-10.074 22.5-22.5 22.5-12.427 0-22.5-10.074-22.5-22.5 0-12.427 10.073-22.5 22.5-22.5z",
    fill: "yellow"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.134 820.678a6.415 23.541 0 11-12.831 0 6.415 23.541 0 1112.83 0z",
    fill: "#89b9db"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1 820.676v-24.5l18.732.314c10.303.173 18.86.441 19.014.597.155.155-.393 1.897-1.218 3.872-3.617 8.657-3.617 30.777 0 39.434.825 1.974 1.373 3.717 1.218 3.872-.155.155-8.711.424-19.014.597l-18.732.314z",
    fill: "#146990"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M342.002 857.687c-6.459-2.117-12.468-6.002-17.166-11.098-4.447-4.825-9.094-13.533-9.11-17.075 0-1.132-.573-2.82-1.26-3.75-1.159-1.569-8.853-1.711-104.75-1.942l-103.5-.249-.317-2.75-.316-2.75h103.866c79.452 0 104.149-.282 105.067-1.2.66-.66 1.204-2.347 1.21-3.75.03-7.787 11.092-21.985 20.878-26.792 5.093-2.503 6.628-2.758 16.612-2.758 10.04 0 11.5.246 16.739 2.819 3.157 1.55 7.837 4.916 10.401 7.48 4.698 4.698 10.357 14.947 10.359 18.76 0 3.922-.62 4.277 10.733 4.582 5.66.152 5.643.699 5.643 3.056 0 2.353.012 2.667-5.609 2.538-12.122-.277-10.766 2.44-10.766 5.995 0 3.827-5.443 14.316-9.742 18.775-2.124 2.203-6.727 5.532-10.228 7.398-5.64 3.007-7.402 3.433-15.448 3.743-5.919.227-10.55-.133-13.296-1.032zM516.56 473.399c-1.708-.283-3.587-1.847-5.265-4.383-2.289-3.459-3.083-3.943-6.47-3.943-3.524 0-3.915-.272-4.485-3.125-1.046-5.226-.899-5.454 3.267-5.056 3.367.32 4.466-.148 8.148-3.474l4.255-3.845 27.302.028 27.3.028 2.552 2.397c2.247 2.11 2.55 3.202 2.55 9.166 0 5.714-.376 7.208-2.412 9.576l-2.413 2.805-25.837.134c-14.21.073-27.032-.065-28.492-.307zm36.583-7.897c2.024-2.024 1.995-4.303-.084-6.6-3.1-3.426-8.345-1.2-8.345 3.543 0 4.397 5.202 6.283 8.429 3.057zm13.743-.084c2.269-2.054 2.325-4.14.174-6.516-3.1-3.426-8.345-1.2-8.345 3.542 0 4.454 4.66 6.15 8.17 2.974zm-30.671-2.845v-3h-8.391c-6.744 0-8.598.327-9.443 1.666-.765 1.213-.685 2.107.295 3.288 1.08 1.3 2.95 1.565 9.442 1.334l8.097-.288zm-381.439-109.25c-2.67-2.163-4.15-8.324-3.37-14.02.433-3.155 1.322-4.815 3.353-6.262 2.586-1.841 4.513-1.968 29.857-1.968h27.093l3.874 3.5c2.978 2.69 4.742 3.5 7.628 3.5 3.67 0 3.74.069 3.129 3.125-.344 1.719-.625 3.519-.625 4 0 .481-1.564.875-3.475.875-2.833 0-3.755.542-4.994 2.94-3.108 6.009-3.388 6.06-33.143 6.06-24.384 0-27.388-.18-29.327-1.75zm40.765-9.17c.452-3.027-1.534-5.08-4.914-5.08-5.168 0-6.412 7.09-1.575 8.97 2.745 1.066 6.045-.912 6.49-3.89zm11.951 3.363c1.241-.87 2.223-2.61 2.223-3.943 0-2.142-3.189-5.5-5.223-5.5-1.356 0-4.777 3.939-4.777 5.5 0 1.56 3.421 5.5 4.777 5.5.428 0 1.778-.7 3-1.557zm-28.278-4.443v-3.5h-10c-9.702 0-10.01.069-10.329 2.323-.695 4.91.074 5.27 10.562 4.963l9.767-.286z",
    fill: "#ed8627"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 130,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#146990"
  }, "\r\n    Geb\xE4ude ist an Glasfasernetz angeschlossen\r\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 380,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#146990"
  }, "\r\n    Glasfasermodem (ONT)\r\n  ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 490,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#146990"
  }, "\r\n    Glasfasermodem (ONT)\r\n  ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 780,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#146990"
  }, "\r\n    Glasfaser-\r\n  ")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 800,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#146990"
  }, "\r\n    Au\xDFenkabel\r\n  ")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 890,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#146990"
  }, "\r\n    Glasfaser-\r\n  ")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 910,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#146990"
  }, "\r\n    Abschlusspunkt\r\n  ")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 930,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#146990"
  }, "\r\n    (Gf-AP)\r\n  ")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 910,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#ed8627"
  }, "\r\n    Netzbetreiber\r\n  ")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 815,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "yellow"
  }, "\r\n    Geb\xE4ude-\r\n  ")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 835,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "yellow"
  }, "\r\n    Eigent\xFCmer\r\n  ")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 872,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 35,
    fontWeight: 700,
    fill: "black",
    stroke: "yellow"
  }, "\r\n    &amp;\r\n  ")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 910,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Sans, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "black",
    stroke: "yellow"
  }, "\r\n    Elektro Krone GmbH\r\n  ")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasfaser);
export default __webpack_public_path__ + "static/media/glasfaser.296a500343b364fde467b9949ba0519e.svg";
export { ForwardRef as ReactComponent };